// src/components/Footer.jsx
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  const handleLinkClick = (path) => {
    // Navigate to the page
    navigate(path);
    
    // Scroll to top of the page
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleHomeClick = () => {
    // If already on home page, just scroll to top
    if (window.location.pathname === '/') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      // Navigate to home and then scroll to top
      navigate('/');
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer style={{
      backgroundColor: 'var(--primary-dark)',
      color: 'white',
      padding: 'var(--space-3xl) 0 var(--space-xl)',
      marginTop: 'auto'
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: 'var(--space-2xl)',
          marginBottom: 'var(--space-2xl)'
        }}>
          {/* Brand */}
          <div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--space-sm)',
              marginBottom: 'var(--space-lg)'
            }}>
              <div style={{
                width: '2.5rem',
                height: '2.5rem',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                borderRadius: 'var(--radius-lg)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.5rem'
              }}>
                🌿
              </div>
              <div style={{
                fontSize: '1.25rem',
                fontWeight: 'bold'
              }}>
                InAndOutDC
              </div>
            </div>
            <p style={{
              color: 'rgba(255, 255, 255, 0.8)',
              lineHeight: 1.6
            }}>
              Washington DC's premier I-71 compliant cannabis
               delivery service. Enjoy fast discreet delivery across
                the DC metro area.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{
              fontSize: 'var(--font-lg)',
              fontWeight: '600',
              marginBottom: 'var(--space-lg)'
            }}>
              Quick Links
            </h4>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 'var(--space-sm)'
            }}>
              <button
                onClick={handleHomeClick}
                style={{
                  color: 'rgba(255, 255, 255, 0.8)',
                  textDecoration: 'none',
                  background: 'none',
                  border: 'none',
                  textAlign: 'left',
                  padding: 0,
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                  fontSize: 'inherit',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'white'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
              >
                Home
              </button>
              <button
                onClick={() => handleLinkClick('/products')}
                style={{
                  color: 'rgba(255, 255, 255, 0.8)',
                  textDecoration: 'none',
                  background: 'none',
                  border: 'none',
                  textAlign: 'left',
                  padding: 0,
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                  fontSize: 'inherit',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'white'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
              >
                Products
              </button>
              <button
                onClick={() => handleLinkClick('/categories')}
                style={{
                  color: 'rgba(255, 255, 255, 0.8)',
                  textDecoration: 'none',
                  background: 'none',
                  border: 'none',
                  textAlign: 'left',
                  padding: 0,
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                  fontSize: 'inherit',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'white'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
              >
                Categories
              </button>
              <button
                onClick={() => handleLinkClick('/about')}
                style={{
                  color: 'rgba(255, 255, 255, 0.8)',
                  textDecoration: 'none',
                  background: 'none',
                  border: 'none',
                  textAlign: 'left',
                  padding: 0,
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                  fontSize: 'inherit',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'white'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
              >
                About Us
              </button>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{
              fontSize: 'var(--font-lg)',
              fontWeight: '600',
              marginBottom: 'var(--space-lg)'
            }}>
              Contact
            </h4>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 'var(--space-sm)',
              color: 'rgba(255, 255, 255, 0.8)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-sm)' }}>
                <span>📞</span>
                <a 
                  href="tel:2024769173"
                  style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    transition: 'color 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = 'white'}
                  onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                >
                  (202) 476-9173
                </a>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-sm)' }}>
                <span>📧</span>
                <a 
                  href="contact@inandoutdc.com"
                  style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    transition: 'color 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = 'white'}
                  onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                >
                  contact@inandoutdc.com
                </a>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-sm)' }}>
                <span>📍</span>
                <span>Washington DC</span>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h4 style={{
              fontSize: 'var(--font-lg)',
              fontWeight: '600',
              marginBottom: 'var(--space-lg)'
            }}>
              Hours
            </h4>
            <div style={{
              color: 'rgba(255, 255, 255, 0.8)',
              lineHeight: 1.6
            }}>
              <p>• Mon -Thur: 9:00 AM - 90:00 pM</p>
              <p>• Fri -Sat: 9:00 AM - 10:00 pM</p>
              <p style={{
                fontSize: 'var(--font-sm)',
                marginTop: 'var(--space-sm)'
              }}>
              • 1-hour delivery available for orders in Washington DC
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.2)',
          paddingTop: 'var(--space-xl)',
          textAlign: 'center',
          color: 'rgba(255, 255, 255, 0.6)',
          fontSize: 'var(--font-sm)'
        }}>
          <p>© 2025 InAndOutDC. All rights reserved.</p>
          <p style={{ marginTop: 'var(--space-sm)' }}>
            * InAndOutDC operates in compliance with Washington DC Initiative 71. Must be 21+ Cannabis provided as gift with purchas. Please consume responsibly.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;